import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus } from 'lucide-react';
const faqs = [{
  question: '¿Con cuánta anticipación debo realizar mi pedido?',
  answer: 'Para asegurar la disponibilidad y frescura de las flores, recomendamos realizar tu pedido con al menos 48 horas de anticipación. Para eventos grandes, sugerimos contactarnos con un mes de antelación.'
}, {
  question: '¿Realizan envíos a domicilio?',
  answer: 'Sí, ofrecemos servicio de entrega a domicilio dentro de la ciudad. El costo varía dependiendo de la zona de entrega.'
}, {
  question: '¿Puedo personalizar mi arreglo floral?',
  answer: 'Absolutamente. Cada arreglo es único. Puedes indicarnos tus preferencias de color, estilo o flores específicas, y nuestro equipo diseñará algo especial para ti, sujeto a la disponibilidad de temporada.'
}, {
  question: '¿Qué métodos de pago aceptan?',
  answer: 'Aceptamos transferencias bancarias, tarjetas de crédito/débito y pagos en efectivo en nuestro estudio.'
}, {
  question: '¿Cómo cuido mis flores para que duren más?',
  answer: 'Te recomendamos cambiar el agua cada dos días, cortar los tallos en diagonal y mantener el arreglo lejos de la luz solar directa y corrientes de aire.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="w-full py-32 md:py-44 px-6" data-id="element-45">
      <div className="max-w-3xl mx-auto" data-id="element-46">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 1,
        ease: [0.2, 0.65, 0.3, 0.9]
      }} className="text-center mb-20 md:mb-24" data-id="element-47">
          <span className="block text-xs md:text-sm tracking-[0.35em] uppercase text-gold mb-6" data-id="element-48">
            Información
          </span>
          <h2 className="text-4xl md:text-6xl text-forest italic mb-6" data-id="element-49">
            Preguntas Frecuentes
          </h2>
          <div className="w-16 h-px bg-gold mx-auto" data-id="element-50" />
        </motion.div>

        {/* Accordion — rounded cards */}
        <div className="space-y-4" data-id="element-51">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.9,
          delay: index * 0.08,
          ease: [0.2, 0.65, 0.3, 0.9]
        }} className={`group rounded-2xl border bg-cream/90 backdrop-blur-sm transition-all duration-300 ${openIndex === index ? 'border-gold shadow-md' : 'border-gold/25 hover:border-gold/50 hover:shadow-sm'}`} data-id="element-52">
              <button onClick={() => toggleFAQ(index)} className="w-full flex justify-between items-center py-6 md:py-7 px-6 md:px-8 text-left focus:outline-none" data-id="element-53">
                <span className="text-lg md:text-2xl pr-8 text-forest transition-colors duration-300" data-id="element-54">
                  {faq.question}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 45 : 0
            }} transition={{
              duration: 0.35,
              ease: 'easeInOut'
            }} className="text-gold flex-shrink-0" data-id="element-55">
                  <Plus strokeWidth={1.5} size={28} data-id="element-56" />
                </motion.div>
              </button>
              <AnimatePresence data-id="element-57">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.4,
              ease: [0.2, 0.65, 0.3, 0.9]
            }} className="overflow-hidden" data-id="element-58">
                    <p className="text-base md:text-lg text-forest/75 pb-7 px-6 md:px-8 pt-0 leading-relaxed" data-id="element-59">
                      {faq.answer}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}